/** data-sources-popup, used both on RC and browser */

<template>
    <div>
        <p class="datasources-link"><a v-on:click.prevent="showModal = true">Data sources</a></p>

        <modal size="medium" vertical-position="top" v-if="showModal" v-on:close="showModal = false">
            <div slot="header">
                <h3>Data sources</h3>
            </div>

            <div slot="body">
                <div class="datasources-content" v-html="content"></div>
            </div>
        </modal>
    </div>
</template>


<script>
import Modal from "./modal.vue";
import { formatXHRError } from "../../js/general-tools.js";
const axios = require("axios");

export default {
    name: "data-sources-popup",
    components: {
        Modal
    },
    props: {},
    data: function () {
        return {
            showModal: false,
            dataLoaded: false,
            content: "Loading data sources..."
        }
    },
    methods: {},
    computed: {},
    watch: {},
    mounted: function () {
        if (!this.dataLoaded) {
            // noinspection JSUnresolvedVariable
            axios.get(mparc.urls.getDataSources)
                .then((data) => {
                    this.content = data.data;
                    this.dataLoaded = true;
                })
                .catch((error) => {
                    this.content = formatXHRError(error, "PATCH")
                })

        }
    }
}
</script>


<style lang="scss">
    @import "../../styles/variables.scss";

    .datasources-link {
        cursor: pointer;
    }

    .datasources-content {
        font-size: 90%;
    }
</style>